<template>
  <div>

    <div class="header pb-6 d-flex align-items-center profile-header py-6">
      <!-- Mask -->
      <span class="mask bg-gradient-default opacity-3"></span>
    </div>

    <div class="container-fluid mt--6">
      <div class="row">
        <div class="col-lg-4 order-lg-2">
          <tarjeta-usuario></tarjeta-usuario>

        </div>
        <div class="col-lg-8 order-lg-1" v-show="(dataUserActual.adminUser==true)">
          <editar-perfil></editar-perfil>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import EditarPerfil from './PerfilUsuario/EditarPerfil.vue';
  import TarjetaUsuario from './PerfilUsuario/TarjetaUsuario.vue';
  import ProgressTrackList from '@/views/Dashboard/ProgressTrackList';
  import { BasePagination, Modal, Dialog } from '@/components';

  import moment from 'moment';
  import swal from 'sweetalert2'
  import 'sweetalert2/dist/sweetalert2.css'

  import AES256 from 'aes-everywhere';
  import Vue from 'vue'
  import axios from 'axios'
  import VueAxios from 'vue-axios'
  import Config from '@/config/config.js'
  import { getUser, setUser, encryptAES, horaAhora, onPermissionsUser } from '@/util/util.js';

  Vue.use(VueAxios, axios)
  Vue.use(Dialog)

  export default {
    components: {
      EditarPerfil,
      TarjetaUsuario,
      ProgressTrackList
    },
    data() {
      return {
        dataUser: {},
        dataUserActual:getUser(),
      }
    },
    methods: {
      obtenerInfoCuenta() {

      let self = this;
      let user = getUser();

      let js = {
        "time_expired":horaAhora(),
        "customer":encodeURIComponent(JSON.stringify(user.customer))
      }

      var body = new URLSearchParams(); body.append('TOKEN', (encryptAES(js)));

      Vue.axios.post(Config.url_service+Config.costumer_user_available, body, {
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      },
      })
        .then(function (response) {

            if (response.data.response == "200") {

              self.dataUser = response.data.data;

              self.dataUser.forEach(function(element) {
                if(element.customerUserId === user.customerUserId) {

                    self.dataUserActual = element;
                    console.log(element)
                }
              })

            } else {
              console.log("No se encontró usuario");
              swal({
                title: 'No se encontró usuario',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
              })
            }

            self.$loading.hide()

        })
        .catch(function (error) {
            console.log("No se encontró usuario",error);
            swal({
                title: 'No se encontró usuario',
                buttonsStyling: false,
                confirmButtonClass: 'btn btn-danger',
                type: 'warning',
            })
            self.$loading.hide();
        });

      },
      fechaFormato(unixTimestamp) {
        return moment(unixTimestamp).format('YYYY-MM-DD');
      },
    },
    mounted() {

     if(!onPermissionsUser('my_data.xhtml', 'view')) {
        swal({
          title: 'No tienes los permisos para acceder a esta página.',
          buttonsStyling: false,
          confirmButtonClass: 'btn btn-danger',
          type: 'error',
          }).then(function() {
            window.location.href="/dashboard";
        })

      }
    }
  };
</script>
<style>
  .profile-header {
    background-image: url(/img/theme/bg-profile.jpg);
    background-size: cover;
    background-position: center center;
    /*min-height: 350px;*/
  }
</style>
